import datePicker from 'vue-bootstrap-datetimepicker';
import moment from 'moment';
import axios from 'axios';

Vue.component('quote-appointment', {
    components: {
        datePicker
    },

    props: ['quote-id', 'lead', 'appointment', 'default-email-subject', 'linked', 'can-link'],

	data () {
		return {
            tpOptions: {
                format: 'DD/MM/YYYY HH:mm',
            },

            sendForm: new Form(),

			form: $.extend(true, new Form({
                data: {
                    type: 'appointment',
                    company: '',
                    contact_name: '',
                    job_title: '',
                    email: '',
                    mobile: '',
                    telephone: '',
                    linkedin: '',
                    website: '',
                    date_of_appointment: '',
                    meeting_via: '',
                    action: '',
                    background: '',
                    turnover: '',
                    employees: '',
                    lead_source: '',
                    additional_emails: [],
                    // email_subject: this.defaultEmailSubject ?? ''
                },

                working: false,
            }), {}),

            leadDeleted: false,

            canSend: this.appointment,
		};
	},

    mounted () {
        if (!this.appointment && this.lead) {
            this.form.data.company = this.lead.contact_company;
            this.form.data.contact_name = this.lead.contact_name;
            this.form.data.job_title = this.lead.job_title;
            this.form.data.email = this.lead.contact_email;
            this.form.data.mobile = this.lead.contact_mobile;
            this.form.data.telephone = this.lead.contact_telephone;
            this.form.data.linkedin = this.lead.linkedin;
            this.form.data.website = this.lead.website;
            this.form.data.employees = this.lead.employees;
            this.form.data.lead_source = this.lead.lead_source;
            this.form.data.email_subject = this.defaultEmailSubject ? this.defaultEmailSubject : '';
        } else if (this.appointment) {
            this.form.data = this.appointment;
	        this.form.data.additional_emails = this.form.data.additional_emails !== null ? this.form.data.additional_emails : [];

            this.form.data.date_of_appointment = moment(this.appointment.date_of_appointment).toDate();
        }
    },

	methods: {
        deleteAttendee (deleteKey) {
            this.form.data.additional_emails = this.form
                .data
                .additional_emails.filter((_, key) => key !== deleteKey);
        },

        addAttendee () {
            this.form.data.additional_emails.push({
                email: '',
                name: '',
            });
        },

		store () {
            Http.post(`/api/appointments/store/${this.quoteId}`, this.form).then(() => {
                this.canSend = true;

                if (!this.linked && this.canLink) {
                    $('#link-leads').modal('show');
                }
            });
		},

        send () {
            this.sending = true;
            Http.post(`/api/appointments/send/${this.quoteId}`, this.sendForm).then(() => {
                this.sending = false;
            });
        },

        removeAppointment () {
            axios.post(`/api/appointments/remove/${this.quoteId}`, {}).then(() => {
                this.form.data.date_of_appointment = null;
                this.leadDeleted = true
            });
        },

        handleJobTitle (v) {
            this.form.data.job_title = v;
        },

        handleEmployees (v) {
            this.form.data.employees = v;
        },

        handleLeadSource (v) {
            this.form.data.lead_source = v;
        }
	}
});
